import { useState, useEffect, useRef } from "react";
import { getJobOffers } from "../../../services/ivrModule/jobServices.js";

const useJobOffersPolling = (workerId, intervalMs = 15000) => {
  const [jobOffer, setJobOffer] = useState(null);
  const [blink, setBlink] = useState(false);

  const pollCountRef = useRef(0); // 👈 Track poll count
  const maxPolls = 2;

  useEffect(() => {
    let intervalId;

    const pollOffers = async () => {

      if (pollCountRef.current >= maxPolls) {
        clearInterval(intervalId);
        return;
      }

      try {
        const offer = await getJobOffers(workerId);
        if (offer && Object.keys(offer).length > 0) {
          setJobOffer(offer);
        } else {
          setJobOffer(null);
        }
      } catch (err) {
        console.error("❌ Error polling job offers:", err);
        setJobOffer(null);
      }

      pollCountRef.current += 1;
    };

    pollOffers(); // initial call
    intervalId = setInterval(pollOffers, intervalMs);

    return () => clearInterval(intervalId);
  }, [workerId, intervalMs]);

  useEffect(() => {
    if (!jobOffer) {
      setBlink(false);
      return;
    }

    const blinkInterval = setInterval(() => setBlink(prev => !prev), 500);
    return () => clearInterval(blinkInterval);
  }, [jobOffer]);

  return { jobOffer, setJobOffer, blink, setBlink };
};

export default useJobOffersPolling;
